import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PinGate from './components/PinGate';
import Home from './pages/Home';
import Days from './pages/Days';
import DayView from './pages/DayView';
import Thoughts from './pages/Thoughts';
import ThoughtView from './pages/ThoughtView';
import Login from './pages/Login';
import Admin from './pages/Admin';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('diary_token');
    const savedUser = localStorage.getItem('diary_user');
    if (token && savedUser) setUser(JSON.parse(savedUser));
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('diary_token', token);
    localStorage.setItem('diary_user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('diary_token');
    localStorage.removeItem('diary_user');
    setUser(null);
  };

  if (loading) return <div className="loading">...</div>;

  return (
    <Router>
      <Routes>
        {/* Admin login bypasses PIN */}
        <Route path="/login" element={user ? <Navigate to="/admin" /> : <Login onLogin={handleLogin} />} />
        <Route path="/admin/*" element={user ? <Admin user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} />

        {/* Public routes behind PIN */}
        <Route path="/*" element={
          <PinGate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/days" element={<Days />} />
              <Route path="/days/:date" element={<DayView />} />
              <Route path="/thoughts" element={<Thoughts />} />
              <Route path="/thoughts/:id" element={<ThoughtView />} />
            </Routes>
          </PinGate>
        } />
      </Routes>
    </Router>
  );
}

export default App;
